import React, {useCallback} from 'react'
import styles from './UIGameTradeCreatorActionButtons.module.scss'
import IconTradeOpponentsCheck from '@static/images/icon_trade_opponents_check.svg'
import {UIGameActionButton} from '../../../common/UIGameActionButton'
import {T} from '@colonist/ui'
import {TradeCreationData, TradeCreationDataValidator, TradeError} from '@colonist/game-mechanic-validators'
import {TranslationObject} from '@colonist/i18n'
import {useGameStore} from '../../../store/GameStoreContext'
import {ACTION_BUTTON_IDS} from '../../UIGameActionButtonsContainer/utils'

export const UIGameTradeCreatorActionButtonTradeWithOpponents = ({
    tradeCreationDataValidator,
    getCurrentTradeCreationData,
    hideTooltip,
}: {
    tradeCreationDataValidator: TradeCreationDataValidator
    getCurrentTradeCreationData: (isBankTrade: boolean) => TradeCreationData
    hideTooltip?: boolean
}) => {
    const onClickCreateTrade = useGameStore((state) => state.gameTrade.onClickCreateTrade)
    const setTradeError = useGameStore((state) => state.gameTrade.setTradeError)
    const tradeCreationData = getCurrentTradeCreationData(false)
    const tradeWithOpponentsError = tradeCreationDataValidator.getTradeCreationDataError(tradeCreationData)
    const hasTradeError = tradeWithOpponentsError != undefined
    const isButtonDisabled = tradeWithOpponentsError?.payload?.isPlayerTradeButtonDisabled == true
    const helperText: TranslationObject | undefined = tradeWithOpponentsError?.error

    const handleErrorOnClick = useCallback(() => {
        if(tradeWithOpponentsError != null) {
            const tradeError: TradeError = {
                error: tradeWithOpponentsError.error,
            }
            if(tradeWithOpponentsError.payload?.highlightCards != null) {
                tradeError.payload = {
                    highlightCards: tradeWithOpponentsError.payload.highlightCards,
                }
            }
            setTradeError(tradeError)
        }
    }, [tradeWithOpponentsError])

    const handleTradeWithOpponentsClick = useCallback(() => {
        if(hasTradeError) {
            handleErrorOnClick()
            return
        }
        onClickCreateTrade(tradeCreationData)
    }, [hasTradeError, tradeCreationData, handleErrorOnClick])

    return <UIGameActionButton
        id={ACTION_BUTTON_IDS.tradePlayers}
        onClick={handleTradeWithOpponentsClick}
        onClickActionIfDisabled={handleErrorOnClick}
        className={styles.actionButton}
        iconClassName={styles.icon}
        iconPath={IconTradeOpponentsCheck}
        tooltipTitle={hideTooltip ? undefined : <T id='strings:game.tooltips.tradeWithOpponents'/>}
        shakingAnimation={hasTradeError}
        disabled={isButtonDisabled}
        helperText={helperText}
    />
}
